import { render, staticRenderFns } from "./ProgresoObservaciones.vue?vue&type=template&id=4173b56f&"
import script from "./ProgresoObservaciones.vue?vue&type=script&lang=js&"
export * from "./ProgresoObservaciones.vue?vue&type=script&lang=js&"
import style0 from "./ProgresoObservaciones.vue?vue&type=style&index=0&id=4173b56f&prod&lang=css&"
import style1 from "./ProgresoObservaciones.vue?vue&type=style&index=1&id=4173b56f&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports